import {
  INCLUDE_CLAUSES,
  OBJECT_TYPES,
} from 'src/tpbp-configuration/models/models.const'
import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'
import type { PortfolioConfigurationModel } from 'src/tpbp-json-api-handler/models/models'
import {
  getConfiguration,
  getConfigurations,
  getRules,
  initConfigurationIfNecessary,
} from 'src/tpbp-json-api-handler/utils/ApiStore'
import type { ProxyRecord } from './deserializers/deserializers.types'
import type { ProductKind } from './mappings/portfolio/portfolio.const'
import type { RequestService } from './request.types'

export async function initPortfolioConfigurationIfNecessary(
  service: RequestService,
) {
  const includes = hasFeature(FEATURE_IDS.evolMvp3)
    ? [
        INCLUDE_CLAUSES.productCategoryConfiguration,
        INCLUDE_CLAUSES.productGroupConfiguration,
        INCLUDE_CLAUSES.productGroupMacroConfiguration,
      ]
    : undefined
  return initConfigurationIfNecessary(OBJECT_TYPES.portfolio, service, includes)
}

export function getPortfolioConfigurations() {
  return getConfigurations<PortfolioConfigurationModel>(OBJECT_TYPES.portfolio)
}

export function getPortfolioConfiguration(
  kind: ProductKind,
): PortfolioConfigurationModel | undefined {
  return getConfiguration<PortfolioConfigurationModel>(
    OBJECT_TYPES.portfolio,
    kind,
  )
}

export function getPortfolioRules(record: ProxyRecord) {
  return getRules(record)
}

export function getPortfolioGroupMacro(
  productKind: ProductKind,
): string | undefined {
  const portfolioConfiguration = getPortfolioConfiguration(productKind)
  return portfolioConfiguration?.productGroupMacro
}

export function getPortfolioProductGroup(productKind: ProductKind) {
  const portfolioConfiguration = getPortfolioConfiguration(productKind)
  return portfolioConfiguration?.productGroup
}

export function getPortfolioProductKindLabel(productKind: ProductKind) {
  const portfolioConfiguration = getPortfolioConfiguration(productKind)
  return portfolioConfiguration?.productKindLabel
}
